import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import React, { FC, PropsWithChildren, type JSX } from 'react';
interface IntegrationProps {
  logo: JSX.Element;
  additionalInfo?: JSX.Element;
}
export const Integration: FC<PropsWithChildren<IntegrationProps>> = t0 => {
  const $ = _c(13);
  const {
    logo,
    additionalInfo,
    children
  } = t0;
  const {
    paymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t1;
  if ($[0] !== logo) {
    t1 = <div className="min-w-[159px]">{logo}</div>;
    $[0] = logo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== additionalInfo) {
    t2 = additionalInfo && <Hint label={additionalInfo} />;
    $[2] = additionalInfo;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex gap-3">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== paymentIntegrations) {
    t4 = paymentIntegrations ? children : <div className="bg-skeleton-primary w-24 animate-pulse rounded-lg py-3 text-transparent">.</div>;
    $[7] = children;
    $[8] = paymentIntegrations;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="[&>svg]:shrink-0 flex flex-col items-center justify-between gap-5 sm:flex-row md:justify-center lg:justify-between lg:gap-24">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};